module.exports = __webpack_public_path__ + "img/sjyy-cwhd-banner-pic.b89865fd.png";